// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3BOi8","log":"ModalInventoryLogs_log__1fkFE","date":"ModalInventoryLogs_date__2m4_5","userName":"ModalInventoryLogs_userName__1Qp1i"};